import api from ".././api";

export const getPropertiesType = async() => {
    return await api.get("/propertyType")
  };
